import { FaInstagram } from 'react-icons/fa';
import { companyInfo } from '../../data/navigation';
import { navigationItems } from '../../data/navigation';
import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Three columns */}
      <div className="footer-middle">
        <div className="footer-column">
          <h4 className="footer-column-title">Navigation</h4>
          <ul className="footer-links">
            {navigationItems.map((item) => (
              <li key={item.path}>
                <a href={item.path}>{item.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="footer-column-title">Services</h4>
          <ul className="footer-links">
            <li><a href="/services/painting">Custom Painting</a></li>
            <li><a href="/services/plaster">Plaster &amp; Venetian</a></li>
            <li><a href="/services/wood-finishing">Wood Finishing</a></li>
            <li><a href="/services/wallpaper">Wallpaper</a></li>
            <li><a href="/services/maintenance">Maintenance</a></li>
            <li><a href="/services/epoxy-floors">Epoxy Flooring</a></li>
            <li><a href="/services/commercial">Commercial</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="footer-column-title">Contact</h4>
          <div className="footer-contact">
            <p>
              <a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a>
            </p>
            <p>
              <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
            </p>
            <p>{companyInfo.address}</p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="footer-divider"></div>

      {/* Bottom Section: Copyright and social */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          &copy; {currentYear} {companyInfo.name}. All rights reserved.
        </p>
        <a
          href={companyInfo.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-instagram"
          aria-label="Visit our Instagram"
        >
          <FaInstagram />
        </a>
      </div>
    </footer>
  );
}
